module.exports = __webpack_public_path__ + "static/media/photostickomni-64.535776b4.png";